import { Fragment } from 'react';

export function TrialPeriods() {
  return (
    <Fragment>
      As outlined in the Payment section, credit cards will not be charged for the duration of the trial period. Users may cancel their subscriptions during this trial period for any reason.
      <br /><br />
      Trial periods may apply to both upgrades from non-payable to payable plans as well as to upgrades from a lower-tier payable plan to a higher-tier payable plan. Trial period Premium feature access will remain in force until the end of the trial period, even if the User cancels subscription to the upgrade plan before the end of the trial.
      <br /><br />
      At the conclusion of the trial period, the subscriber’s credit card will be charged the appropriate amount and automatic renewal will be set for one month from the start of the trial period or in accordance with the User’s choice of period of validity (bimonthly, annually, biannually, and any other period offered by us).
      <br /><br />
      There are no trial periods for CityFALCON Coins.
    </Fragment>
  );
}


export default TrialPeriods;
